<template>
  <div class="my-list-empty">
      <span class="ico-component-empty">
        <EmptyIcon />
      </span>
    <p>이용한 콘텐츠가 없어요.</p>
    <p>지금 바로 시청해 보시는 건 어때요?</p>
    <a href="" @click.prevent="goHomeFn" class="my-empty-btn">
      <span>홈으로 이동하기</span>
      <NextButtonGrey></NextButtonGrey>
    </a>
  </div>
</template>

<script>
import NextButtonGrey from '@/assets/svg/common/ic-next-s-g.svg'
import EmptyIcon from '@/assets/svg/common/img_empty.svg'
export default {
  name: 'TasteAnalysisEmpty',
  components: {
    NextButtonGrey,
    EmptyIcon
  },
  props: {
    goHomeFn: {
      type: Function
    }
  }
}
</script>
